export const PORTAL_USER_INACTIVE_ERROR = 'PORTAL_USER_INACTIVE';
export const ACCOUNT_DEACTIVATED_LOGIN_MESSAGE = 'Sua conta foi desativada.';

let pendingAccountDeactivatedLogout = false;

export function markAccountDeactivatedLogout(): void {
  pendingAccountDeactivatedLogout = true;
}

export function peekAccountDeactivatedLogout(): boolean {
  return pendingAccountDeactivatedLogout;
}

export function consumeAccountDeactivatedLogout(): boolean {
  const value = pendingAccountDeactivatedLogout;
  pendingAccountDeactivatedLogout = false;
  return value;
}

export function isPortalUserInactiveErrorMessage(message: string): boolean {
  return message.trim() === PORTAL_USER_INACTIVE_ERROR;
}
